import {FunctionComponent, useCallback, useState} from 'react';
import Dialog from '@/components/dialog';

const Dialogs: FunctionComponent = () => {
  const [isVisible, setIsVisible] = useState(false);

  const onClick = useCallback(() => {
    setIsVisible(true);
  }, []);

  const onClose = useCallback(() => {
    setIsVisible(false);
  }, []);

  return (
    <div className="flex flex-col gap-5">
      <div>
        <button onClick={onClick}>Ouvrir la modale</button>
      </div>

      <Dialog isVisible={isVisible} onClose={onClose}>
        <Dialog.Header title="Répartitions préétablies" onClose={onClose} />

        <Dialog.Content>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid sint, dolor dicta doloribus deserunt,
            nostrum exercitationem optio quas ipsa quisquam esse iure! Nostrum dolor molestias architecto sapiente,
            explicabo saepe reiciendis!
          </p>
        </Dialog.Content>
      </Dialog>
    </div>
  );
};

export default Dialogs;
